import { Link } from 'react-router-dom';

const quickCategories = [
  { name: '动作片', icon: 'ri-fire-line' },
  { name: '爱情片', icon: 'ri-heart-3-line' },
  { name: '科幻片', icon: 'ri-rocket-2-line' },
  { name: '喜剧片', icon: 'ri-emotion-happy-line' },
  { name: '悬疑片', icon: 'ri-search-eye-line' },
  { name: '剧情片', icon: 'ri-film-line' },
  { name: '奇幻片', icon: 'ri-magic-line' },
  { name: '冒险片', icon: 'ri-compass-3-line' },
  { name: '惊悚片', icon: 'ri-alarm-warning-line' },
];

export default function CategoryQuick() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-12 bg-background-100">
      <div className="max-w-screen mx-auto">
        <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-3 md:gap-4">
          {quickCategories.map((cat) => (
            <Link
              key={cat.name}
              to={`/movies?category=${encodeURIComponent(cat.name)}`}
              className="group flex flex-col items-center gap-2 py-4 rounded-lg bg-background-50 border border-background-300/50 hover:border-primary-500/70 transition-colors"
            >
              <span className="w-11 h-11 rounded-full bg-accent-800 group-hover:bg-primary-500 flex items-center justify-center transition-colors">
                <i className={`${cat.icon} text-xl text-primary-400 group-hover:text-background-50`}></i>
              </span>
              <span className="text-xs md:text-sm text-foreground-800 group-hover:text-primary-400 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}